import { RowMiddle } from 'layout/Components/Row'
import React from 'react'
import { Trans } from 'react-i18next'
import { Icons } from 'svgs'
import colors from 'theme/ui/colors'
import Box from 'UIKit/Box/Box'
import Text from 'UIKit/Text'

interface GameFilterSelectedOptionProps {
  value: string
}

const GameFilterSelectedOption: React.FC<GameFilterSelectedOptionProps> = ({ value }) => (
  <RowMiddle>
    <Box mr="2px" style={{ transform: 'scale(0.8)' }}>
      <Icons.GameFilterIcon fill={colors.textSubtle} width="22px" height="22px" />
    </Box>

    <Text fontSize="12px" color="textSubtle" fontWeight={500}>
      <Trans>{value}</Trans>
    </Text>
  </RowMiddle>
)

export default GameFilterSelectedOption
